export default function (to, from, next) {
    if (to.fullPath.includes('%2F')) {
        return next(to.fullPath.replace('%2F', '/'));
    } else {
        return next();
    }
}
